// CAREER LIST FILTER

const originalLists = document.querySelectorAll('.original-list');

originalLists.forEach(originalList => {
  const rolesText = originalList.textContent.trim();
  
  const rolesArray = rolesText.split(',');
  
  let newListItems = [];
  
  rolesArray.forEach(role => {
    const trimmedRole = role.trim();
    if (trimmedRole !== '') {
      const dataTag = trimmedRole.toLowerCase().replace(/\s+/g, '-');
      newListItems.push(`<li data-tag="${dataTag}">${trimmedRole}</li>`);
    }
  });
  
  originalList.innerHTML = newListItems.join('');
});

// -------------------------------------------------------------------------------------

document.addEventListener('DOMContentLoaded', function () {
    const filterBlocks = document.querySelectorAll('.filter-block');
    const careerItems = document.querySelectorAll('.careers-block-item');
    const noResultsMessage = document.querySelector('.careers-block .no-results');
    
    const filters = {
        role: null,
        level: null,
        location: null,
        contract: null
    };

    filterBlocks.forEach(block => {
        const filterType = block.getAttribute('data-filter');
        const filterItems = block.querySelectorAll('ul.original-list li');
        const activeFilterItem = block.querySelector('.active-filter-item');

        filterItems.forEach(item => {
            item.addEventListener('click', function () {
                filterItems.forEach(i => i.classList.remove('active'));
                item.classList.add('active');
                const tag = item.getAttribute('data-tag');
                filters[filterType] = tag;
                activeFilterItem.textContent = item.textContent;
                filterCareerItems();
            });
        });
    });

    function filterCareerItems() {
        let visibleItemCount = 0;
        
        careerItems.forEach(item => {
            const role = item.getAttribute('data-role');
            const level = item.getAttribute('data-level');
            const location = item.getAttribute('data-location');
            const contract = item.getAttribute('data-contract');
            
            const isVisible = (
                (!filters.role || filters.role === role) &&
                (!filters.level || filters.level === level) &&
                (!filters.location || filters.location === location) &&
                (!filters.contract || filters.contract === contract)
            );

            item.classList.toggle('hidden', !isVisible);
            if (isVisible) {
                visibleItemCount++;
            }
        });

        noResultsMessage.classList.toggle('hidden', visibleItemCount > 0);
    }
});
document.addEventListener('DOMContentLoaded', function () {
    const filterBlocks = document.querySelectorAll('.filter-block');
    const careerItems = document.querySelectorAll('.careers-block-item');
    const noResultsMessage = document.querySelector('.careers-block .no-results');
    
    const filters = {
        role: null,
        level: null,
        location: null,
        contract: null
    };

    filterBlocks.forEach(block => {
        const filterType = block.getAttribute('data-filter');
        const filterItems = block.querySelectorAll('ul.original-list li');
        const activeFilterItem = block.querySelector('.active-filter-item');

        filterItems.forEach(item => {
            item.addEventListener('click', function () {
                filterItems.forEach(i => i.classList.remove('active'));
                item.classList.add('active');
                const tag = item.getAttribute('data-tag');
                filters[filterType] = tag;
                activeFilterItem.textContent = item.textContent;
                filterCareerItems();
            });
        });
    });

    function filterCareerItems() {
        let visibleItemCount = 0;
        
        careerItems.forEach(item => {
            const role = item.getAttribute('data-role');
            const level = item.getAttribute('data-level');
            const location = item.getAttribute('data-location');
            const contract = item.getAttribute('data-contract');
            
            const isVisible = (
                (!filters.role || filters.role === role) &&
                (!filters.level || filters.level === level) &&
                (!filters.location || filters.location === location) &&
                (!filters.contract || filters.contract === contract)
            );

            item.classList.toggle('hidden', !isVisible);
            if (isVisible) {
                visibleItemCount++;
            }
        });

        noResultsMessage.classList.toggle('hidden', visibleItemCount > 0);
    }
});

const accordion_title = document.querySelectorAll(".accordion-item")
const plus_minus = document.querySelectorAll(".plus_minus")

accordion_title.forEach((accord, index) => {
   accord.addEventListener('click', function() {
      if (accord.classList.contains('open')) {
        accord.classList.remove('open');
      } else {
        accordion_title.forEach(i => i.classList.remove('open'));
        accord.classList.add('open');
      }
    })
})

// -------------------------------------------------------------------------------------

document.addEventListener("DOMContentLoaded", function() {
    document.addEventListener("click", function(event) {
        if (event.target.classList.contains("active-filter-item")) {
            var filterBlock = event.target.closest(".filter-block");
            if (filterBlock) {
                var allFilterBlocks = document.querySelectorAll(".filter-block");
                allFilterBlocks.forEach(function(block) {
                    if (block !== filterBlock) {
                        block.classList.remove("active");
                    }
                });
                filterBlock.classList.toggle("active");
            }
        } else if (event.target.closest(".original-list")) {
            var originalList = event.target.closest(".original-list");
            var filterBlocks = document.querySelectorAll(".filter-block");
            filterBlocks.forEach(function(block) {
                block.classList.remove("active");
            });
        }
    });
});

